import { useCallback, useState } from 'react';
import SysAdminRoleFormComponent from '../components/sysadmin-role-form.component';
import { RoleCreate, RoleUpdate } from '../types/role.types';
import { useRoleCreate } from '../hooks/use-role.hook';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  extractCreateError,
  extractValidationError,
} from '../../../../../services/extract-api-error.service';
import HeaderRow from '../../../../common/HeaderRow';
import { ValidationError } from '../../../../../types/api-response.types';
import { useTranslation } from 'react-i18next';
import { WithSysAdminPermissionCheck } from '../../../../auth/WithSysAdminPermissionCheck';
import PageTitle from '@components/common/PageTitle';

const SysAdminRoleCreateContainer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [validationErrors, setValidationErrors] = useState<ValidationError[]>([]);

  const { mutateAsync: createRole, isPending } = useRoleCreate();

  const onFormSubmit = useCallback(
    async (data: RoleCreate | RoleUpdate, resetForm: () => void) => {
      // Reset validation errors on new submission
      setValidationErrors([]);

      // For create operations, we know we'll have all required fields
      const createData = data as RoleCreate;
      try {
        const response = await createRole(createData);
        message.success(t('crud.create.success', { entity: t('roles.title') }));
        resetForm();
        navigate(`/dashboard/admin/role/${response.data.id}/update`);
      } catch (error: any) {
        const errorFields = extractValidationError(error);
        setValidationErrors(errorFields);
        const errorMessage = extractCreateError(
          error,
          t('crud.create.error', { entity: t('roles.title') })
        );
        message.error(errorMessage);
      }
    },
    [createRole, navigate, t]
  );

  return (
    <>
      <PageTitle title={t('crud.create.title', { entity: t('roles.title') })} />
      <HeaderRow
        title={t('crud.create.title', { entity: t('roles.title') })}
        showBackButton={true}
        isSysAdmin={true}
      />
      <div className="row mt-3">
        <SysAdminRoleFormComponent
          onFormSubmit={onFormSubmit}
          isLoading={isPending}
          validationErrors={validationErrors}
        />
      </div>
    </>
  );
};

export default WithSysAdminPermissionCheck(SysAdminRoleCreateContainer, 'role.create');
